import { queryFor } from "@visioni/a3s-client-api/app";
import { listNotificationPreferencesEndpoint, getContactPhoneNumberEndpoint } from "../client-messages";

/**
 * React Query options factory for the calling user's saved notification preferences.
 * Tenant-scoped with no extra path params — usage: `notificationPreferencesQuery(apiConfig, {})`.
 */
export const notificationPreferencesQuery = queryFor(listNotificationPreferencesEndpoint);

/**
 * React Query options factory for the calling user's saved contact phone number.
 * Tenant-scoped with no extra path params — usage: `contactPhoneNumberQuery(apiConfig, {})`.
 */
export const contactPhoneNumberQuery = queryFor(getContactPhoneNumberEndpoint);
